function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 5a3 3 0 013 3v14a3 3 0 01-3 3H8a3 3 0 01-3-3V8a3 3 0 013-3h14z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M22 7H8a1 1 0 00-.993.883L7 8v14a1 1 0 00.883.993L8 23h14a1 1 0 00.993-.883L23 22V8a1 1 0 00-.883-.993L22 7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 16.5l2.5 3.01L17.5 15l4.5 6H8z"
});

function SvgQImageTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default SvgQImageTypeIcon;